module.exports = "<app-dashboard-sidebar></app-dashboard-sidebar>\n<app-dashboard-people-list type=\"patients\"></app-dashboard-people-list>\n"